import { getSolvtaxApiOrigin } from "../config/apiBaseUrl";

/**
 * Pings GET /api/health on the solvtax-api origin and logs connectivity status
 * to the browser console for quick local and staging diagnostics.
 */
export async function pingApiHealth() {
  const url = `${getSolvtaxApiOrigin()}/api/health`;

  console.log("[API HEARTBEAT] Pinging backend...", url, "(origin:", getSolvtaxApiOrigin(), ")");

  try {
    const response = await fetch(url);
    const body = await response.json().catch(() => null);

    if (response.ok) {
      console.log("[API HEARTBEAT] Backend online:", body);
    } else {
      console.warn("[API HEARTBEAT] Backend degraded:", {
        status: response.status,
        body,
      });
    }

    return { ok: response.ok, status: response.status, body };
  } catch (error) {
    console.error("[API HEARTBEAT] Backend unreachable:", error);
    return { ok: false, error };
  }
}
